const artistsPT = {
    "view": {
        "table": {
            "title": "Sua lista de artistas",
            "column": {
                "name": "Nome do Artista",
                "owner": "Proprietário",
                "spotify_link": "Link do Spotify",
                "apple_music_link": "Link do Apple Music",
                "amazon_music_link": "Link do Amazon Music",
                "deezer_link": "Link do Deezer",
                "flagged": "Marcado",
                "blacklisted": "Na lista negra",
                "action": "Ação"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "message": {
                "artistFlagged": "Este artista está marcado e é necessário pagamento em depósito para distribuir o lançamento no Spotify.",
                "artistNotFlagged": "Este artista é elegível para distribuição no Spotify.",
                "artistBlacklisted": "Este artista está na lista negra e não é elegível para distribuição.",
                "artistNotBlacklisted": "Este artista não está na lista negra e é elegível para distribuição.",
            }
        },
        "message": {
            "success": "Artista foi removido!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "notSubscribed": "Você não está inscrito em nenhum plano, portanto, só pode adicionar <strong>3 Artistas</strong>. Por favor, <3>inscreva-se</3> em um plano para ter acesso ilimitado a Artistas.",
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para ter acesso a este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>renove</1> sua assinatura para ter acesso a este recurso.",
            "noAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações."
        },
        "modal": {
            "cantBeDeleted": {
                "header": "Artista {{artistName}} não pode ser deletado",
                "body": "O artista {{artistName}} não pode ser deletado pois já possui Faixa(s)/Lançamento(s) associados a ele."
            },
            "delete": {
                "header": "Deletar {{artistName}}?",
                "body": "Tem certeza de que realmente deseja deletar este artista? Esta ação pode desvincular seu artista do lançamento atribuído."
            },
            "edit": {
                "header": "Editar {{artistName}}?",
                "body": "Tem certeza de que deseja alterar o nome do seu artista? Isso pode afetar os metadados do lançamento."
            }
        }
    },
    "add": {
        "title": "Adicionar Artista",
        "form": {
            "label": {
                "is_new_artist": "É Novo Artista",
                "spotify_profile": "Perfil do Spotify",
                "deezer_profile": "Perfil do Deezer",
                "amazon_music_profile": "Perfil do Amazon Music",
                "spotify_image": "Imagem do Spotify",
                "deezer_image": "Imagem do Deezer",
                "amazon_music_image": "Imagem do Amazon Music",
                "spotify_id": "ID do Spotify",
                "deezer_id": "ID do Deezer",
                "amazon_music_id": "ID do Amazon Music",
                "apple_id": "ID do Apple",
                "name": "Nome",
                "name_preference": "Preferência de Nome",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Sub-Usuário"
            },
            "help_text": {
                "is_new_artist": "Você está adicionando um novo artista, ou seja, se seu artista tem lançamentos no Spotify/Deezer/Amazon Music/Apple Music, selecione Não, caso contrário, selecione Sim.",
                "spotify_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Spotify, caso contrário, clique no botão Não Encontrado.",
                "deezer_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Deezer, caso contrário, clique no botão Não Encontrado.",
                "amazon_music_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Amazon Music, caso contrário, clique no botão Não Encontrado.",
                "apple_id": "Nota: Use este campo apenas se quiser adicionar um Artista que já está no Apple Music, caso contrário, clique no botão Não Encontrado.",
                "subuser": "Nota: Use este menu suspenso apenas se quiser Adicionar Artista para qualquer um dos seus Sub-usuários, caso contrário, deixe não selecionado."
            },
            "placeholder": {
                "subuser": "Selecione Sub-usuário...",
                "spotify_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ID do Spotify do Artista, ou seja, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ID do Deezer do Artista, ou seja, 1406580",
                "amazon_music_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ASIN do Amazon do Artista, ou seja, B005GI0T2U",
                "apple_id": "Por favor, insira um ID Apple válido. Exemplo: 635806095"
            },
            "button": {
                "reset": "Redefinir",
                "not_found": "Não Encontrado",
                "submit": "Enviar"
            },
            "option": {
                "yes": "Sim",
                "no": "Não"
            },
            "validation": {
                "name_required": "Nome é obrigatório",
                "name_invalid": "O nome do artista deve conter 'DJ' apenas em maiúsculas",
                "email_required": "Email é obrigatório",
                "email_invalid": "Por favor, insira um email válido",
                "name_duplicate": "Artista já existe",
                "name_mismatch": "O nome do artista deve corresponder em todas as lojas",
                "spotify_id_invalid": "Por favor, adicione um ID Spotify válido. Exemplo: 6eUKZXaKkcviH0Ku9w2n3B. Consulte nosso Centro de Ajuda para mais informações.",
                "apple_id_required": "ID Apple é obrigatório",
                "apple_id_invalid": "Por favor, adicione um ID Apple válido. Exemplo: 635806095. Consulte nosso Centro de Ajuda para mais informações."
            }
        },
        "modal": {
            "title": {
                "new_artist_declaration": "Declaração de Novo Artista",
                "profile_not_present_declaration": "Declaração de Perfil Não Presente"
            },
            "body": {
                "profile_not_present_declaration": "Confirmo que o perfil deste Artista não está presente na <strong>{{store}}</strong> e que o perfil deste Artista seja criado recentemente na <strong>{{store}}</strong>.",
                "new_artist_declaration": "Confirmo que o perfil deste Artista não está presente em nenhuma das seguintes lojas e que o perfil deste Artista seja criado recentemente nessas lojas.",
                "new_artist_declaration_amazon_music": "Amazon Music",
                "new_artist_declaration_apple_music": "Apple Music",
                "new_artist_declaration_deezer": "Deezer",
                "new_artist_declaration_spotify": "Spotify"
            },
            "button": {
                "confirm": "Confirmar",
                "cancel": "Cancelar"
            }
        },
        "message": {
            "success": "Artista foi adicionado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "errorBlacklisted": "Uma ou mais das detalhes que você forneceu estão relacionadas a um artista que está na lista negra. Se você está certo de que o artista não está na lista negra, por favor, entre em contato com o time de suporte para mais informações."
        }
    },
    "update": {
        "title": "Editar Artista",
        "form": {
            "label": {
                "spotify_profile": "Perfil do Spotify",
                "deezer_profile": "Perfil do Deezer",
                "amazon_music_profile": "Perfil do Amazon Music",
                "spotify_image": "Imagem do Spotify",
                "deezer_image": "Imagem do Deezer",
                "amazon_music_image": "Imagem do Amazon Music",
                "spotify_id": "ID do Spotify",
                "deezer_id": "ID do Deezer",
                "amazon_music_id": "ID do Amazon Music",
                "apple_id": "ID do Apple",
                "name": "Nome",
                "name_preference": "Preferência de Nome",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "flagged": "Marcado"
            },
            "help_text": {
                "spotify_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Spotify, caso contrário, clique no botão Não Encontrado.",
                "deezer_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Deezer, caso contrário, clique no botão Não Encontrado.",
                "amazon_music_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Amazon Music, caso contrário, clique no botão Não Encontrado.",
                "apple_id": "Nota: Use este campo apenas se quiser adicionar um Artista que já está no Apple Music, caso contrário, clique no botão Não Encontrado."
            },
            "placeholder": {
                "spotify_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ID do Spotify do Artista, ou seja, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ID do Deezer do Artista, ou seja, 1406580",
                "amazon_music_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ASIN do Amazon do Artista, ou seja, B005GI0T2U",
                "apple_id": "Por favor, insira um ID Apple válido. Exemplo: 635806095"
            },
            "button": {
                "reset": "Redefinir",
                "not_found": "Não Encontrado",
                "submit": "Enviar"
            },
            "validation": {
                "name_required": "Nome é obrigatório",
                "email_required": "Email é obrigatório",
                "email_invalid": "Por favor, insira um email válido",
                "name_duplicate": "Artista já existe",
                "name_mismatch": "O nome do artista deve corresponder em todas as lojas",
                "name_mismatch_spotify": "O Nome do Perfil do Spotify deve corresponder ao Nome do Artista",
                "name_mismatch_deezer": "O Nome do Perfil do Deezer deve corresponder ao Nome do Artista",
                "name_mismatch_amazon_music": "O Nome do Perfil do Amazon deve corresponder ao Nome do Artista",
                "spotify_id_invalid": "Por favor, adicione um ID Spotify válido. Exemplo: 6eUKZXaKkcviH0Ku9w2n3B. Consulte nosso Centro de Ajuda para mais informações.",
                "apple_id_required": "ID Apple é obrigatório",
                "apple_id_invalid": "Por favor, adicione um ID Apple válido. Exemplo: 635806095. Consulte nosso Centro de Ajuda para mais informações."
            }
        },
        "modal": {
            "title": {
                "profile_reset_declaration": "Declaração de Redefinição de Perfil",
                "profile_not_present_declaration": "Declaração de Perfil Não Presente"
            },
            "body": {
                "profile_not_present_declaration": "Confirmo que o perfil deste Artista não está presente na <strong>{{store}}</strong> e que o perfil deste Artista seja criado recentemente na <strong>{{store}}</strong>.",
                "profile_reset_declaration": "Estou ciente de que ao redefinir o perfil do <strong>{{store}}</strong> deste Artista, o <strong>ID do {{store}}</strong> será removido de todo o sistema e, ao fazer isso, é provável que cause interrupções nas lojas e artistas para não corresponderem."
            },
            "button": {
                "confirm": "Confirmar",
                "cancel": "Cancelar"
            }
        },
        "message": {
            "success": "Artista de nome '{{artistName}}' foi atualizado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "errorBlacklisted": "Uma ou mais das detalhes que você forneceu estão relacionadas a um artista que está na lista negra. Se você está certo de que o artista não está na lista negra, por favor, entre em contato com o time de suporte para mais informações."
        }
    },
    "add_from_wishlist": {
        "title": "Adicionar Artista",
        "form": {
            "label": {
                "spotify_profile": "Perfil do Spotify",
                "deezer_profile": "Perfil do Deezer",
                "amazon_music_profile": "Perfil do Amazon Music",
                "spotify_id": "ID do Spotify",
                "spotify_image": "Imagem do Spotify",
                "deezer_id": "ID do Deezer",
                "deezer_image": "Imagem do Deezer",
                "amazon_music_id": "ID do Amazon",
                "amazon_music_image": "Imagem do Amazon Music",
                "apple_id": "ID do Apple",
                "apple_image": "Imagem do Apple",
                "name": "Nome",
                "name_preference": "Preferência de Nome",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Sub-Usuário"
            },
            "placeholder": {
                "spotify_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ID do Spotify do Artista, ou seja, 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ID do Deezer do Artista, ou seja, 1406580",
                "amazon_music_profile": "Digite o Nome do Artista, ou seja, The Weekend ou o ASIN do Amazon do Artista, ou seja, B005GI0T2U",
                "apple_id": "Por favor, insira um ID Apple válido. Exemplo: 635806095",
                "subuser": "Selecione Sub-usuário..."
            },
            "help_text": {
                "spotify_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Spotify, caso contrário, clique no botão Não Encontrado.",
                "deezer_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Deezer, caso contrário, clique no botão Não Encontrado.",
                "amazon_music_profile": "Nota: Use este menu suspenso apenas se quiser adicionar um Artista que já está no Amazon Music, caso contrário, clique no botão Não Encontrado.",
                "apple_id": "Nota: Use este campo apenas se quiser adicionar um Artista que já está no Apple Music, caso contrário, clique no botão Não Encontrado.",
                "subuser": "Nota: Use este menu suspenso apenas se quiser Adicionar Artista para qualquer um dos seus Sub-usuários, caso contrário, deixe não selecionado."
            },
            "button": {
                "reset": "Redefinir",
                "notFound": "Não Encontrado?",
                "submit": "Enviar",
                "cancel": "Cancelar",
                "confirm": "Confirmar"
            },
            "validation": {
                "name_required": "Nome é obrigatório",
                "email_required": "Email é obrigatório",
                "email_invalid": "Por favor, insira um email válido",
                "spotify_id_invalid": "Por favor, adicione um ID Spotify válido. Exemplo: 6eUKZXaKkcviH0Ku9w2n3B. Consulte nosso Centro de Ajuda para mais informações.",
                "apple_id_required": "ID Apple é obrigatório",
                "apple_id_invalid": "Por favor, adicione um ID Apple válido. Exemplo: 635806095. Consulte nosso Centro de Ajuda para mais informações."
            },
            "message": {
                "errorArtistExists": "Artista já existe",
                "errorNameMismatch": "O nome do artista deve corresponder em todas as lojas",
                "errorSpotifyNameMismatch": "O Nome do Perfil do Spotify deve corresponder ao Nome do Artista",
                "errorDeezerNameMismatch": "O Nome do Perfil do Deezer deve corresponder ao Nome do Artista",
                "errorAmazonNameMismatch": "O Nome do Perfil do Amazon deve corresponder ao Nome do Artista"
            }
        },
        "message": {
            "success": "Artista foi adicionado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "errorBlacklisted": "Uma ou mais das detalhes que você forneceu estão relacionadas a um artista que está na lista negra. Se você está certo de que o artista não está na lista negra, por favor, entre em contato com o time de suporte para mais informações."
        },
        "modal": {
            "profileMissing": {
                "header": "Declaração de Perfil Não Presente",
                "body": "Confirmo que o perfil deste Artista não está presente na <strong>{{storeName}}</strong> e que o perfil deste Artista seja criado recentemente na <strong>{{storeName}}</strong>.",
                "button": {
                    "cancel": "Cancelar",
                    "confirm": "Confirmar"
                }
            }
        }
    },
    "viewDetails": {
        "view": {
            "label": {
                "followers": "SEGUIDORES",
                "popularity": "POPULARIDADE",
                "genres": "GÊNEROS",
                "flagged": "MARCADO",
                "notAvailable": "Não Disponível",
                "notAvailableAbbr": "N/D"
            },
            "similarArtists": {
                "title": "Artistas Similares",
                "table": {
                    "column": {
                        "artist": "Artista",
                        "followers": "Seguidores",
                        "popularity_pct": "Popularidade (%)",
                        "genres": "Gêneros",
                        "wishlist": "Lista de Desejos"
                    }
                },
                "label": {
                    "notAvailable": "Não Disponível",
                    "notAvailableAbbr": "N/D"
                },
                "message": {
                    "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
                },
                "modal": {
                    "addToWishlist": {
                        "header": "Adicionar Artista {{artistName}} à Lista de Desejos",
                        "body": "Tem certeza de que deseja adicionar o artista {{artistName}} à sua lista de desejos?",
                        "message": {
                            "success": "Artista adicionado à lista de desejos!"
                        }
                    },
                    "removeFromWishlist": {
                        "header": "Remover Artista {{artistName}} da Lista de Desejos",
                        "body": "Tem certeza de que deseja remover o artista {{artistName}} da sua lista de desejos?"
                    }
                }
            },
            "topTracks": {
                "title": "Principais Faixas",
                "table": {
                    "column": {
                        "track": "Faixa",
                        "release": "Lançamento",
                        "artists": "Artista(s)",
                        "popularity_pct": "Popularidade (%)",
                        "preview": "Prévia"
                    }
                },
                "label": {
                    "audioElementNotSupported": "Seu navegador não suporta o elemento de áudio."
                }
            }
        }
    }
};

export default artistsPT;